<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">

      <h4 class="d-flex align-items-center">
        <font-awesome-icon icon="fas fa-laptop-house" />
        <span class="ml-1">收據資料</span>
      </h4>
      <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- receipt number -->
              <b-col cols="12" md="6">
                <validation-provider #default="validationContext" name="收據編號" rules="required" vid="v_receipt_number">
                  <b-form-group label="收據編號：" label-for="receipt_number" label-cols-md="3" class="required">
                    <b-input-group>
                      <b-form-input id="receipt_number" v-model="newReceiptData.receipt_number" placeholder="輸入收據編號"
                        :state="getValidationState(validationContext)" @blur="validateReceiptNumber"
                        @input="onReceiptNumberInput"
                        :disabled="loadingReceiptNumber || !ability.can('edit_number', 'receipt_form')"
                        :readonly="!ability.can('edit_number', 'receipt_form')" />
                      <b-input-group-append>
                        <b-button variant="outline-secondary" @click="getNextReceiptNumber"
                          :disabled="loadingReceiptNumber || !ability.can('edit_number', 'receipt_form')" size="sm">
                          <b-spinner small v-if="loadingReceiptNumber" />
                          <span v-else>自動</span>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                    <small v-if="receiptNumberValidation.message" :class="receiptNumberValidation.isValid
                      ? 'text-success'
                      : 'text-danger'
                      ">
                      {{ receiptNumberValidation.message }}
                    </small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- customer_id -->
              <b-col cols="12" md="6">
                <validation-provider #default="validationContext" name="此欄" rules="required" vid="v_customer_id">
                  <b-form-group label="客戶：" label-for="customer_id" label-cols-md="3" class="required">
                    <v-select id="customer_id" v-model="newReceiptData.customer_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="customerOptions" :clearable="false"
                      label="name" :reduce="(option) => option.id" placeholder="選擇客戶" :disabled="newReceiptData.id > 0"
                      @input="handleCustomerChange" :filter="customerSearch">
                      <template #option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                      <template #selected-option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                    </v-select>

                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- receipt_date -->
              <b-col cols="12" md="6">
                <validation-provider #default="validationContext" name="此欄" rules="required" vid="v_receipt_date">
                  <b-form-group label="收據日期：" label-for="receipt_date" label-cols-md="3">
                    <flat-pickr v-model="newReceiptData.receipt_date" class="form-control" :config="{
                      allowInput: true,
                      altInput: true,
                      altFormat: 'Y-m-d',
                      dateFormat: 'Y-m-d',
                    }" placeholder="輸入YYYY-MM-DD" />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- project_id -->
              <!-- <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_project_id"
                >
                  <b-form-group
                    label="項目："
                    label-for="id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="project_id"
                      v-model="newReceiptData.project_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="newProjectOptions"
                      :clearable="false"
                      label="project_name"
                      :reduce="(option) => option.id"
                      @input="handleProjectChange"
                      :filter="projectSearch"
                      :placeholder="
                        newReceiptData.customer_id ? '選擇項目' : '請先選擇客戶'
                      "
                      :disabled="
                        !newReceiptData.customer_id || newReceiptData.id > 0
                      "
                    >
                      <template #option="{ project_name, project_number }">
                        [{{ project_number }}] {{ project_name }}
                      </template>
                      <template
                        #selected-option="{ project_name, project_number }"
                      >
                        [{{ project_number }}] {{ project_name }}
                      </template>
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col> -->

              <!-- <b-col cols="12">
                <hr />
              </b-col> -->
              <!-- 
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="發票編號"
                  rules="required"
                >
                  <b-form-group
                    label="發票編號："
                    label-for="receipt-invoice-id"
                    label-cols-md="3"
                  >
                    <v-select
                      id="invoice_id"
                      v-model="newReceiptData.invoice_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="invoiceOptions"
                      :clearable="false"
                      label="invoice_number"
                      :reduce="(option) => option.id"
                      placeholder="選擇發票"
                    >
                    </v-select>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>


              <b-col cols="12">
                <hr />
              </b-col> -->

              <!-- project_name -->
              <!-- <b-col cols="12" md="6">
                  <b-form-group
                    label="項目名稱："
                    label-for="id"
                    label-cols-md="3"
                    class=""
                  >
                    <b-form-input
                      id="project_name"
                      v-model="newReceiptData.project_name"
                      placeholder="輸入項目名稱"
                    />
                  </b-form-group>
              </b-col> -->

              <!-- address -->
              <b-col cols="12" md="6">
                <!-- <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_address"
                > -->
                <b-form-group label="施工地址：" label-for="address" label-cols-md="3">
                  <!-- class="required" -->
                  <b-form-input id="address" v-model="newReceiptData.address" placeholder="輸入施工地址" />
                  <!-- :state="getValidationState(validationContext)"
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
                </b-form-group>
                <!-- </validation-provider> -->
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- customer name_cn-->
              <b-col cols="12" md="6">
                <validation-provider #default="validationContext" name="此欄" rules="required" vid="v_name_cn">
                  <b-form-group label="單據抬頭：" label-for="c_name_cn" label-cols-md="3">
                    <b-form-input id="c_name_cn" v-model="newReceiptData.name_cn" placeholder="輸入單據抬頭"
                      :state="getValidationState(validationContext)" />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- customer name_en-->
              <b-col cols="12" md="6">
                <b-form-group label="系統帳號名稱：" label-for="c_name_en" label-cols-md="3" class="required">
                  <b-form-input id="c_name_cn" v-model="newReceiptData.name_en" placeholder="輸入系統帳號名稱" />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- customer mobile-->
              <b-col cols="12" md="6">
                <validation-provider #default="validationContext" name="此欄" rules="required" vid="v_mobile">
                  <b-form-group label="聯絡電話：" label-for="customer_mobile" label-cols-md="3" class="required">
                    <b-form-input id="customer_mobile" v-model="newReceiptData.mobile" placeholder="輸入聯絡電話"
                      :state="getValidationState(validationContext)" />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- customer email-->
              <b-col cols="12" md="6">
                <b-form-group label="電郵地址：" label-for="email" label-cols-md="3">
                  <b-form-input id="customer_email" v-model="newReceiptData.email" placeholder="輸入電郵地址" />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- receipt_items -->
              <b-col cols="12">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <span>收據詳情</span>
                </div>

                <p class="text-danger">非首次生成收據，請查閱客戶上一次已付金額記錄，收據欄目上階段付款金額是銷售發票中列出的數據。避免核數時出錯，必須翻查！ </p>

                <b-row v-for="(receipt, index) in newReceiptData.receipt_items" :key="`receipt_${index}`" class="px-1">

                  <!-- invoice_id {{receipt.invoice_id}} -->
                  <b-col cols="12" class="d-flex backgroundColor5 mb-1 radius-round border-1">
                    <b-row class="flex-grow-1 p-2">
                      <b-col cols="12" md="6">
                        <!-- invoice_id -->
                        <validation-provider #default="validationContext" :vid="`v-invoice_id${index}`" name="此欄"
                          rules="required">
                          <b-form-group label="發票:" :label-for="`receipt-date${index}`" label-cols-md="3"
                            class="required">
                            <v-select id="invoice_id" v-model="receipt.invoice_id" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                              " :options="invoices" :clearable="false" :reduce="(option) => option.id"
                              :filter="invoiceSearch" :placeholder="newReceiptData.customer_id
                                ? '選擇發票'
                                : '請先選擇客戶'
                                " :disabled="!newReceiptData.customer_id"
                              @input="(val) => invoiceSelected(receipt, val)">
                              <!-- :options="filteredOptions(index)" -->
                              <template #option="{
                                invoice_number,
                                invoice_date,
                                amount,
                                total_paid,
                              }">
                                [{{ invoice_number }}]
                                {{ invoice_date }} 總額:${{
                                  formatAmount(amount)
                                }}
                                已付:${{ formatAmount(total_paid) }}
                                {{
                                  getUnpaidAmount(amount, total_paid) > 0
                                    ? "未付:$" +
                                    formatAmount(
                                      getUnpaidAmount(
                                        amount,
                                        total_paid
                                      )
                                    )
                                    : "已付清"
                                }}
                              </template>
                              <template #selected-option="{
                                invoice_number,
                                invoice_date,
                                amount,
                                total_paid,
                              }">
                                [{{ invoice_number }}]
                                {{ invoice_date }} 總額:${{
                                  formatAmount(amount)
                                }}
                                已付:${{ formatAmount(total_paid) }}
                                {{
                                  getUnpaidAmount(amount, total_paid) > 0
                                    ? "未付:$" +
                                    formatAmount(
                                      getUnpaidAmount(
                                        amount,
                                        total_paid
                                      )
                                    )
                                    : "已付清"
                                }}
                                {{
                                  calTotalRemainDepositAmount(
                                    receipt.invoice_id
                                  ) > 0
                                    ? "尚欠第一次付款:$" +
                                    calTotalRemainDepositAmount(
                                      receipt.invoice_id
                                    )
                                    : ""
                                }}
                              </template>
                            </v-select>
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>

                        <b-form-group label="選擇付款階段：" :label-for="`receipt-payment-step-select${index}`"
                          label-cols-md="3">
                          <div v-if="
                            !isPaymentStepOptionsLoaded(receipt.invoice_id)
                          " class="text-muted">
                            載入付款階段選項中... ({{ forceUpdateCounter }})
                          </div>
                          <v-select v-else :key="`payment-step-${receipt.invoice_id}-${index}-${forceUpdateCounter}`"
                            :id="`receipt-payment-step-select${index}`" v-model="receipt.payment_step_id"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="getPaymentStepOptions(receipt.invoice_id)" :clearable="true" label="display_text"
                            :reduce="(option) => option.id" placeholder="選擇付款階段" :disabled="!receipt.invoice_id"
                            :filterable="false" @input="
                              (val) => handlePaymentStepChange(receipt, val)
                            " @open="
                              () =>
                                ensurePaymentStepOptionsLoaded(
                                  receipt.invoice_id
                                )
                            ">
                            <template #option="{ display_text }">
                              {{ display_text }}
                            </template>
                            <template #selected-option="option">
                              <span v-if="option && option.display_text">
                                {{ option.display_text }}
                              </span>
                              <span v-else>
                                {{
                                  getPaymentStepDisplayTextById(
                                    receipt.invoice_id,
                                    receipt.payment_step_id
                                  )
                                }}
                              </span>
                            </template>
                            <template #no-options>
                              <span v-if="!receipt.invoice_id">請先選擇發票</span>
                              <span v-else-if="
                                !isPaymentStepOptionsLoaded(
                                  receipt.invoice_id
                                )
                              ">載入中...</span>
                              <span v-else>此發票沒有付款階段</span>
                            </template>
                          </v-select>
                        </b-form-group>
                        <!-- amount -->
                        <!-- 非 Re-Print 模式：正常的金額輸入 -->
                        <validation-provider v-if="!receipt.is_reprint" #default="validationContext"
                          :vid="`v-amount${index}`" name="付款金額" rules="required">
                          <b-form-group label="付款金額" :label-for="`receipt-amount${index}`" label-cols-md="3"
                            class="required">
                            <b-form-input :id="`receipt-amount${index}`" v-model="receipt.amount" type="number"
                              step="0.01" @input="calTotalAmount" :state="getValidationState(validationContext)"
                              placeholder="請輸入金額" />
                            <b-form-invalid-feedback>
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>

                        <!-- Re-Print 模式：顯示兩個欄位 -->
                        <div v-else>
                          <!-- 收據金額（可編輯，通常為 0） -->
                          <validation-provider #default="validationContext" :vid="`v-amount${index}`" name="收據金額"
                            rules="required">
                            <b-form-group label="收據金額" :label-for="`receipt-amount${index}`" label-cols-md="3"
                              class="required">
                              <b-form-input :id="`receipt-amount${index}`" v-model="receipt.amount" type="number"
                                step="0.01" readonly :state="getValidationState(validationContext)"
                                placeholder="Re-Print 模式金額" style="background-color: #e5e5e5" />
                              <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                              <small class="text-muted">
                                Re-Print 模式：通常設為 $0 以避免重複計算
                              </small>
                            </b-form-group>
                          </validation-provider>

                          <!-- 階段總額（只讀參考） -->
                          <b-form-group label="階段總額（參考）" :label-for="`receipt-original-amount${index}`"
                            label-cols-md="3">
                            <b-form-input :id="`receipt-original-amount${index}`" :value="formatAmount(
                              receipt.original_amount ||
                              getPaymentStepAmount(
                                receipt.invoice_id,
                                receipt.payment_step_id
                              )
                            )
                              " readonly placeholder="階段原始金額" style="background-color: #e5e5e5" />
                            <small class="text-muted">
                              此付款階段的原始金額，僅供參考
                            </small>
                          </b-form-group>
                        </div>
                      </b-col>
                      <b-col cols="12" md="6">
                        <validation-provider #default="validationContext" :vid="`v-deposit-date${index}`" name="此欄"
                          rules="required">
                          <b-form-group label="收款日期：" :label-for="`receipt-date${index}`" label-cols-md="3"
                            class="required">
                            <flat-pickr v-model="receipt.payment_date" class="form-control" :config="{
                              allowInput: true,
                              altInput: true,
                              altFormat: 'Y-m-d',
                              dateFormat: 'Y-m-d',
                            }" placeholder="輸入YYYY-MM-DD" />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                        <validation-provider #default="validationContext" :vid="`v-payment_method_id${index}`" name="此欄"
                          rules="required">
                          <b-form-group label="收款方式：" label-for="payment_method_id" label-cols-md="3" class="required">
                            <v-select :id="`receipt-payment_method_id${index}`" v-model="receipt.payment_method_id"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                                " :options="paymentMethodOptions.filter(
                                  (item) => item.id !== 18
                                )
                                  " :clearable="false" label="name" :reduce="(option) => option.id" placeholder="選擇收款方式"
                              :filter="paymentMethodSearch" @input="
                                (value) => handlePaymentMethod(value, index)
                              ">
                            </v-select>

                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                        <b-form-group label="支票號碼：" label-for="check_number" label-cols-md="3">
                          <b-form-input v-model="receipt.check_number" :disabled="receipt.payment_method_id !== 1"
                            placeholder="輸入支票號碼(只有收款方式是支票需要)" />
                        </b-form-group>

                        <!-- item_description -->
                        <!-- <b-form-group
                          label="款項摘要："
                          label-for="item_description"
                          label-cols-md="3"
                        >
                          <textarea
                            v-model="receipt.item_description"
                            class="w-100"
                          />
                        </b-form-group> -->
                      </b-col>
                    </b-row>
                    <div class="d-flex flex-column justify-content-between py-50 px-25">
                      <feather-icon size="16" icon="PlusIcon" class="cursor-pointer text-success"
                        @click="addItem(index)" />
                      <feather-icon size="16" icon="XIcon" class="cursor-pointer text-danger"
                        @click="removeItem(index, receipt.id)" />
                    </div>
                  </b-col>
                </b-row>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- amount -->
              <b-col cols="12">
                <div class="d-flex justify-content-end">
                  <validation-provider #default="validationContext" name="此欄" rules="required" vid="v_amount">
                    <b-form-group label="總額：" label-for="amount" label-cols-md="3" class="require">
                      <b-form-input id="receipt_amount" v-model="newReceiptData.amount" placeholder="輸入總額"
                        :state="getValidationState(validationContext)" />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </div>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- payment method id-->
              <b-col cols="12" md="6">
                <validation-provider #default="validationContext" name="此欄" rules="required" vid="v_payment_method_id">
                  <b-form-group label="總收款方式：" label-for="payment_method_id" label-cols-md="3" class="required">
                    <v-select id="payment_method_id" v-model="newReceiptData.payment_method_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="paymentMethodOptions"
                      :clearable="false" label="name" :reduce="(option) => option.id" placeholder="選擇收款方式"
                      :filter="paymentMethodSearch">
                    </v-select>

                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- <b-col cols="12" md="6">
                <b-form-group
                  label="支票號碼："
                  label-for="check_number"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="check_number"
                    v-model="newReceiptData.check_number"
                    :disabled="newReceiptData.payment_method_id !== 1"
                    placeholder="輸入支票號碼(只有收款方式是支票需要)"
                    :key="`check_number_${trigger}`"
                  />
                </b-form-group>
              </b-col> -->

              <!-- pay_date -->
              <!-- <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="收款日期"
                  rules="required"
                >
                  <b-form-group
                    label="收款日期："
                    label-for="pay_date"
                    label-cols-md="3"
                    class="required"
                  >
                    <flat-pickr
                      v-model="newReceiptData.pay_date"
                      class="form-control"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        dateFormat: 'Y-m-d',
                      }"
                      placeholder="輸入YYYY-MM-DD"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col> -->

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- company stamp -->
              <!-- <b-col cols="12" md="6">
               
                <b-form-group
                  label="公司印章："
                  label-for="stamp_id"
                  label-cols-md="3"
                >
                  <b-form-checkbox
                    :checked="newReceiptData.stamp"
                    name="stamp"
                    switch
                    inline
                    v-model="newReceiptData.stamp"
                    value="1"
                    style="margin-top: 5px"
                  >
                    {{ newReceiptData.stamp ? "有" : "無" }}
                  </b-form-checkbox>

                </b-form-group>
              </b-col> -->

              <!-- template id -->
              <b-col cols="12" md="6">
                <validation-provider #default="validationContext" name="模版" rules="required">
                  <b-form-group label="選擇模版：" label-for="stamp" label-cols-md="3" class="required">
                    <v-select id="stamp" v-model="newReceiptData.template_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="templateOptions" :clearable="false"
                      label="template_name" :reduce="(option) => option.id" placeholder="選擇模版" @input="changeTemplate"
                      :filter="templateSearch">
                    </v-select>

                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- stamp_id -->
              <b-col cols="12" md="6">
                <b-form-group label="選擇印章：" label-for="stamp" label-cols-md="3">
                  <v-select id="stamp" v-model="newReceiptData.stamp_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="stampOptions" :clearable="true"
                    label="name" :reduce="(option) => option.id" placeholder="選擇印章" :filter="stampSearch">
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>

            <div>
              <div class="mt-3">
                <hr />
                <div>單據備註：</div>
                <b-form-group label="" label-for="receipt_document_description_id">
                  <v-select id="receipt_document_description_id"
                    v-model="newReceiptData.receipt_document_description_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="receiptDocumentDescriptionOptions"
                    :filter="receiptDocumentDescriptionSearch" :clearable="true" label="name"
                    :reduce="(option) => option.id" placeholder="選擇單據備註"
                    :disabled="!ability.can('receipt_remark', 'receipt_form')"
                    :readonly="!ability.can('receipt_remark', 'receipt_form')">
                  </v-select>
                </b-form-group>
                <b-form-group label="" label-for="remark">
                  <b-form-textarea id="remark" v-model="newReceiptData.remark" placeholder="輸入單據備註" autofocus trim
                    class="textarea" :key="`remark${trigger}`"
                    :disabled="!ability.can('receipt_remark', 'receipt_form')"
                    :readonly="!ability.can('receipt_remark', 'receipt_form')" />
                </b-form-group>
              </div>
              <div class="mt-3">
                <div>備註 Remarks：</div>
                <b-form-group label="" label-for="remark_id">
                  <v-select id="remark_id" v-model="newReceiptData.remark_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="receiptRemarkOptions"
                    :clearable="true" label="title" :reduce="(option) => option.id" placeholder="選擇備註"
                    :filter="receiptRemarkSearch" :disabled="!ability.can('pdf_remark', 'receipt_form')
                      " :readonly="!ability.can('pdf_remark', 'receipt_form')
                        ">
                  </v-select>
                </b-form-group>
                <!-- {{ receiptRemarkOptions }} -->
                <b-form-group label="" label-for="receipt_remark">
                  <b-form-textarea id="receipt_remark" v-model="newReceiptData.receipt_remark" placeholder="備註"
                    autofocus trim class="textarea" :key="`receipt_remark_${trigger}`" :disabled="!ability.can('pdf_remark', 'receipt_form')
                      " :readonly="!ability.can('pdf_remark', 'receipt_form')
                        " />
                </b-form-group>
                <hr />
                <b-row>
                  <b-col cols="12">
                    地址: {{ info.address || "未設定" }}
                  </b-col>
                  <b-col cols="12" md="6">
                    網址: {{ info.website || "未設定" }}
                  </b-col>
                  <b-col cols="12" md="6">
                    電話: {{ info.phone || "未設定" }}
                  </b-col>
                  <b-col cols="12" md="6">
                    電郵: {{ info.email || "未設定" }}
                  </b-col>
                  <b-col cols="12" md="6">
                    傳真: {{ info.fax || "未設定" }}
                  </b-col>
                </b-row>
              </div>
            </div>

            <div class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-sm-2 mobile-w100"
                type="submit">
                <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
                提交
              </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" variant="outline-secondary"
                @click="hide" class="mt-1 mt-sm-0 mobile-w100">
                取消
              </b-button>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BOverlay,
  BSpinner,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch, onMounted } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import ability from "@/libs/acl/ability";

export default {
  data() {
    return {
      required,
      email,
      ability,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    BRow,
    BCol,
    BButton,
    BOverlay,
    BSpinner,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  props: {
    receiptData: {
      type: Object,
      required: true,
    },
    invoiceOptions: {
      type: Array,
      required: true,
    },
    projectOptions: {
      type: Array,
      required: true,
    },
    customerOptions: {
      type: Array,
      required: true,
    },
    paymentMethodOptions: {
      type: Array,
      required: true,
    },
    receiptRemarkOptions: {
      type: Array,
      required: true,
    },
    templateOptions: {
      type: Array,
      required: true,
    },
    stampOptions: {
      type: Array,
      required: true,
    },
    receiptDescriptionOptions: {
      type: Array,
      required: true,
    },
    receiptDocumentDescriptionOptions: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit, root }) {
    const newReceiptData = ref({
      id: 0,
      stamp_id: 1,
      template_id: 1,
      remark_id: 3,
      customer_id: null,
      name_cn: "",
      name_en: "",
      mobile: "",
      email: "",
      project_id: null,
      project_name: "",
      address: "",
      receipt_items: [
        {
          id: 0,
          invoice_id: null,
          amount: null,
          payment_date: null,
          item_description: null,
          is_deposit: 0,
          payment_method_id: null,
          payment_step_id: null,
          is_reprint: false,
        },
      ],
      receipt_date: new Date().toISOString().substr(0, 10),
    });

    const trigger = ref(false);
    const invoices = ref([]);
    const loadingReceiptNumber = ref(false);
    const isInitReceiptDocumentDescription = ref(true);
    const isInitReceiptRemark = ref(true);
    const isInitReceiptRemarkId = ref(true);
    const isInitReceiptDocumentDescriptionId = ref(true);
    const receiptNumberValidation = ref({
      message: "",
      isValid: true,
    });

    const info = ref({
      website: null,
      address: null,
      phone: null,
      fax: null,
      email: null,
    });

    const changeTemplate = (id) => {
      console.log("changeTemplate called with id:", id);
      console.log("templateOptions:", props.templateOptions);

      // 重置範本資訊
      info.value = {
        website: null,
        address: null,
        phone: null,
        fax: null,
        email: null,
      };

      // 如果沒有提供 ID 或 ID 無效，則不處理
      if (!id || id <= 0) {
        console.log("無效的範本 ID");
        return;
      }

      // 查找對應的範本
      if (props.templateOptions && props.templateOptions.length > 0) {
        const template = props.templateOptions.find((ele) => ele.id == id);
        if (template) {
          info.value.website = template.website || "";
          info.value.address = template.address || "";
          info.value.phone = template.phone || "";
          info.value.fax = template.fax || "";
          info.value.email = template.email || "";
          console.log("範本資訊已更新:", info.value);
        } else {
          console.log("找不到對應的範本");
        }
      } else {
        console.log("沒有可用的範本選項");
      }
    };
    // init for 已有或由發票生成收據
    const is_init = ref(false);

    watch(
      () => props.receiptData,
      async (newVal) => {
        console.log("=== watch props.receiptData 被觸發 ===", {
          newVal: newVal,
          hasReceiptData: !!newVal,
          receiptId: newVal?.id,
          customerId: newVal?.customer_id,
          receiptItemsCount: newVal?.receipt_items?.length || 0
        });

        // 保留用戶可能已經修改的備註內容
        const existingRemark = newReceiptData.value.remark;
        const existingReceiptRemark = newReceiptData.value.receipt_remark;
        console.log("💾 保存現有備註:", { remark: existingRemark, receipt_remark: existingReceiptRemark });

        newReceiptData.value = { ...newVal };

        // 如果用戶已經修改了備註內容，保留用戶的修改
        if (existingRemark && existingRemark !== '' && existingRemark !== newVal.remark) {
          console.log("🔄 恢復用戶自訂的單據備註:", existingRemark);
          newReceiptData.value.remark = existingRemark;
        }
        if (existingReceiptRemark && existingReceiptRemark !== '' && existingReceiptRemark !== newVal.receipt_remark) {
          console.log("🔄 恢復用戶自訂的備註 Remarks:", existingReceiptRemark);
          newReceiptData.value.receipt_remark = existingReceiptRemark;
        }

        // 修正：如果 remark 是物件（來自關聯），確保它是字串
        if (newReceiptData.value.remark && typeof newReceiptData.value.remark === 'object') {
          console.log("檢測到 remark 是物件，將其設為空字串:", newReceiptData.value.remark);
          newReceiptData.value.remark = '';
        }

        // 修正：確保 remark_id 是數字或字串，不是物件
        if (newReceiptData.value.remark_id && typeof newReceiptData.value.remark_id === 'object') {
          console.log("檢測到 remark_id 是物件，提取 id:", newReceiptData.value.remark_id);
          newReceiptData.value.remark_id = newReceiptData.value.remark_id.id || null;
        }

        // 修正：確保 receipt_document_description_id 是數字或字串，不是物件
        if (newReceiptData.value.receipt_document_description_id && typeof newReceiptData.value.receipt_document_description_id === 'object') {
          console.log("檢測到 receipt_document_description_id 是物件，提取 id:", newReceiptData.value.receipt_document_description_id);
          newReceiptData.value.receipt_document_description_id = newReceiptData.value.receipt_document_description_id.id || null;
        }

        console.log("newReceiptData", newReceiptData.value);
        changeTemplate(newReceiptData.value.template_id);

        // 如果是新收據且沒有編號，自動獲取下一個編號
        if (
          (!newReceiptData.value.id || newReceiptData.value.id === 0) &&
          !newReceiptData.value.receipt_number
        ) {
          getNextReceiptNumber();
        }

        // 設定備註內容（如果 remark_id 存在但 receipt_remark 為空）
        if (
          newReceiptData.value.remark_id &&
          !newReceiptData.value.receipt_remark
        ) {
          setRemarkContent();
        }

        // **修復：簡化發票載入邏輯，確保編輯收據時總是載入客戶的所有發票**
        if (newReceiptData.value.customer_id) {
          console.log('watch receiptData: 載入客戶發票', {
            客戶ID: newReceiptData.value.customer_id,
            收據ID: newReceiptData.value.id,
            是否為編輯模式: newReceiptData.value.id > 0,
            收據項目數量: newReceiptData.value.receipt_items?.length || 0,
            收據項目: newReceiptData.value.receipt_items?.map(item => ({
              id: item.id,
              invoice_id: item.invoice_id,
              has_invoice_object: !!item.invoice
            }))
          });

          try {
            // 總是調用 API 載入客戶的所有發票，確保發票選項完整
            const response = await store.dispatch(`receipt/fetchCustomerInvoice`, {
              id: newReceiptData.value.customer_id,
            });
            invoices.value = response.data.invoices;
            console.log('watch receiptData: 從API載入的發票信息', {
              發票數量: response.data.invoices.length,
              發票列表: response.data.invoices.map(inv => ({
                id: inv.id,
                invoice_number: inv.invoice_number,
                invoice_date: inv.invoice_date,
                amount: inv.amount
              }))
            });

            // 如果是編輯現有收據，為現有收據項目載入付款階段選項
            if (newReceiptData.value.id > 0 && newReceiptData.value.receipt_items && newReceiptData.value.receipt_items.length > 0) {
              const uniqueInvoiceIds = [
                ...new Set(
                  newReceiptData.value.receipt_items
                    .map((item) => item.invoice_id)
                    .filter((id) => id)
                ),
              ];
              console.log('編輯模式：需要載入付款階段的發票ID:', uniqueInvoiceIds);
              for (const invoiceId of uniqueInvoiceIds) {
                // 優先使用收據項目中的發票數據載入付款階段選項
                const receiptItem = newReceiptData.value.receipt_items.find(item => item.invoice_id === invoiceId);
                if (receiptItem && receiptItem.invoice && (receiptItem.invoice.paymentSteps || receiptItem.invoice.payment_steps)) {
                  console.log(`使用收據項目中的發票 ${invoiceId} 數據載入付款階段選項`);
                  await loadPaymentStepOptionsFromInvoiceData(invoiceId, receiptItem.invoice);
                } else {
                  console.log(`使用API載入發票 ${invoiceId} 的付款階段選項`);
                  await loadPaymentStepOptions(invoiceId);
                }
              }
            }

            is_init.value = true;
          } catch (error) {
            console.error('載入客戶發票失敗:', error);
          }
        }
      },
      { immediate: true }
    );

    const newProjectOptions = ref([]);
    watch(
      () => newReceiptData.value.customer_id,
      (newVal) => {
        if (props.customerOptions && props.customerOptions.length > 0) {
          const customer = props.customerOptions.find(
            (ele) => ele.id == newReceiptData.value.customer_id
          );
          if (customer) {
            newReceiptData.value.name_cn = customer.name_cn;
            newReceiptData.value.name_en = customer.name;
            newReceiptData.value.mobile = customer.phone;
            newReceiptData.value.email = customer.email;
          }
        }

        if (props.projectOptions && props.projectOptions.length > 0) {
          newProjectOptions.value = props.projectOptions.filter(
            (ele) => ele.customer_id == newReceiptData.value.customer_id
          );
        }

        // 當客戶ID改變時，自動調用handleCustomerChange來載入發票和填入地址
        // 但在編輯模式下，如果是初次載入資料，不應該清空已有的 invoice_id
        if (newVal && newVal !== null) {
          // 檢查是否為編輯模式且是初次載入
          const isEditMode = newReceiptData.value.id > 0;
          const hasExistingInvoiceIds = newReceiptData.value.receipt_items.some(item => item.invoice_id);

          if (isEditMode && hasExistingInvoiceIds && !is_init.value) {
            console.log("編輯模式：跳過 handleCustomerChange，保留現有的 invoice_id");
            // 只載入客戶發票，不清空現有的 invoice_id
            if (newReceiptData.value.customer_id) {
              store.dispatch(`receipt/fetchCustomerInvoice`, {
                id: newReceiptData.value.customer_id,
              }).then((response) => {
                invoices.value = response.data.invoices;
                console.log("編輯模式：僅載入客戶發票，保留現有 invoice_id");
              });
            }
          } else {
            handleCustomerChange();
          }
        }
      }
    );

    // handleDescription 函數已移除，因為現在直接綁定到 item_description
    const handleCustomerChange = () => {
      newReceiptData.value.project_id = null;
      newReceiptData.value.project_name = "";
      newReceiptData.value.address = "";
      newReceiptData.value.receipt_items.forEach((item) => {
        item.invoice_id = null;
      });

      // 獲取客戶發票並同時處理地址自動填入
      if (newReceiptData.value.customer_id) {
        console.log("handleCustomerChange: 開始載入客戶發票，客戶ID:", newReceiptData.value.customer_id);
        store
          .dispatch(`receipt/fetchCustomerInvoice`, {
            id: newReceiptData.value.customer_id,
          })
          .then((response) => {
            // 設置發票選項
            invoices.value = response.data.invoices;
            console.log("handleCustomerChange: 成功載入發票", {
              客戶ID: newReceiptData.value.customer_id,
              發票數量: response.data.invoices.length,
              發票列表: response.data.invoices.map(inv => ({
                id: inv.id,
                invoice_number: inv.invoice_number,
                invoice_date: inv.invoice_date,
                amount: inv.amount
              }))
            });

            // 自動從第一張發票獲取施工地址
            if (response.data.invoices && response.data.invoices.length > 0) {
              const firstInvoice = response.data.invoices[0];
              if (firstInvoice.address && firstInvoice.address.trim() !== "") {
                newReceiptData.value.address = firstInvoice.address;
                console.log("自動填入施工地址:", firstInvoice.address);
              }
            }
          })
          .catch((error) => {
            console.error("獲取客戶發票失敗:", error);
          });
      }

      console.log("handleCustomerChange");
    };

    // 項目選擇功能已註釋，保留函數以防需要
    // const handleProjectChange = () => {
    //   console.log("handleProjectChange");
    //   newReceiptData.value.project_name = newProjectOptions.value.find(
    //     (ele) => ele.id == newReceiptData.value.project_id
    //   ).project_name;
    //   newReceiptData.value.address = newProjectOptions.value.find(
    //     (ele) => ele.id == newReceiptData.value.project_id
    //   ).project_name;

    //   newReceiptData.value.receipt_items.forEach((item) => {
    //     item.invoice_id = null;
    //   });
    // };

    const selectedOptions = ref([]);

    watch(
      () => {
        return newReceiptData.value.receipt_items.map(
          (item) => item.invoice_id
        );
      },
      (newInvoiceIds) => {
        selectedOptions.value = newInvoiceIds;
        console.log("selectedOptions.value", selectedOptions.value);
      },
      { deep: true }
    );

    const filteredOptions = (idx) => {
      if (invoices.value && invoices.value.length > 0) {
        var arr = invoices.value.filter(
          (option) => !selectedOptions.value.includes(option.id)
        );

        if (selectedOptions.value[idx]) {
          var currentIdxSelectItem = invoices.value.find(
            (ele) => ele.id === selectedOptions.value[idx]
          );
          arr.push(currentIdxSelectItem);
        }

        let newArr = [];
        if (arr) {
          newArr = arr.filter((item, index, self) => {
            return !self.slice(index + 1).some((obj) => obj.id === item.id);
          });
        }

        return newArr;
      } else {
        return [];
      }
    };
    // 設定備註內容的通用函數
    const setRemarkContent = () => {
      // 檢查是否為編輯模式且已有自訂內容
      if (
        router.currentRoute.name === "receipt-edit" &&
        newReceiptData.value.receipt_remark &&
        newReceiptData.value.receipt_remark !== ''
      ) {
        console.log("編輯模式且已有自訂備註內容，跳過自動填入");
        return;
      }

      if (
        props.receiptRemarkOptions &&
        props.receiptRemarkOptions.length > 0 &&
        newReceiptData.value.remark_id
      ) {
        const remark = props.receiptRemarkOptions.find(
          (ele) => ele.id == newReceiptData.value.remark_id
        );
        if (remark && remark.content) {
          console.log(
            "設定備註內容 - ID:",
            newReceiptData.value.remark_id,
            "內容:",
            remark.content
          );
          newReceiptData.value.receipt_remark = remark.content;
        }
      }
    };

    watch(
      () => newReceiptData.value.remark_id,
      (newVal) => {
        console.log("收據 remark_id 變更:", newVal);

        // 檢查是否為編輯模式的初始載入
        if (
          router.currentRoute.name === "receipt-edit" &&
          isInitReceiptRemarkId.value
        ) {
          console.log("收據編輯模式初始載入，跳過備註 Remarks 自動填入（remark_id watch）");
          isInitReceiptRemarkId.value = false;
          return;
        }

        console.log("props.receiptRemarkOptions", props.receiptRemarkOptions);
        if (
          props.receiptRemarkOptions &&
          props.receiptRemarkOptions.length > 0 &&
          newVal
        ) {
          var remark = props.receiptRemarkOptions.find(
            (ele) => ele.id == newVal
          );
          if (remark) {
            console.log("用戶主動選擇備註 Remarks，更新內容 - ID:", newVal, "內容:", remark.content);
            // 用戶主動選擇時，總是更新內容
            newReceiptData.value.receipt_remark = remark.content;
          }
        }

        trigger.value = !trigger.value;
      }
    );
    // 監聽 receiptRemarkOptions 的變化，當選項加載完成時設定備註內容
    watch(
      () => props.receiptRemarkOptions,
      (newVal) => {
        console.log("receiptRemarkOptions 更新:", newVal);

        // 檢查是否為編輯模式的初始載入
        if (
          router.currentRoute.name === "receipt-edit" &&
          isInitReceiptRemark.value
        ) {
          console.log("收據編輯模式初始載入，跳過備註 Remarks 自動填入");
          isInitReceiptRemark.value = false;
          return;
        }

        if (newVal && newVal.length > 0 && newReceiptData.value.remark_id) {
          const remark = newVal.find(
            (ele) => ele.id == newReceiptData.value.remark_id
          );
          if (remark && remark.content) {
            console.log(
              "選項載入完成，自動填入收據備註模板內容 - ID:",
              newReceiptData.value.remark_id,
              "內容:",
              remark.content
            );
            // 只有在 receipt_remark 為空時才自動填入模板內容
            if (!newReceiptData.value.receipt_remark || newReceiptData.value.receipt_remark === '') {
              newReceiptData.value.receipt_remark = remark.content;
            }
          }
        }
      },
      { immediate: true }
    );

    // 監聽單據備註選擇變化，自動填入內容
    watch(
      () => newReceiptData.value.receipt_document_description_id,
      (newVal) => {
        console.log("收據 receipt_document_description_id 變更:", newVal);

        // 檢查是否為編輯模式的初始載入
        if (
          router.currentRoute.name === "receipt-edit" &&
          isInitReceiptDocumentDescriptionId.value
        ) {
          console.log("收據編輯模式初始載入，跳過單據備註自動填入（receipt_document_description_id watch）");
          isInitReceiptDocumentDescriptionId.value = false;
          return;
        }

        if (
          props.receiptDocumentDescriptionOptions &&
          props.receiptDocumentDescriptionOptions.length > 0 &&
          newVal
        ) {
          const description = props.receiptDocumentDescriptionOptions.find(
            (ele) => ele.id == newVal
          );
          if (description && description.description) {
            console.log(
              "用戶主動選擇收據單據備註，更新內容 - ID:",
              newVal,
              "內容:",
              description.description
            );
            // 當用戶主動選擇時，總是更新內容
            newReceiptData.value.remark = description.description;
          }
        } else if (!newVal) {
          // 當清除選擇時，也清除備註內容
          newReceiptData.value.remark = '';
        }
        trigger.value = !trigger.value;
      }
    );

    // 監聽 receiptDocumentDescriptionOptions 的變化，當選項加載完成時設定單據備註內容
    watch(
      () => props.receiptDocumentDescriptionOptions,
      (newVal) => {
        console.log("receiptDocumentDescriptionOptions 更新:", newVal);

        // 檢查是否為編輯模式的初始載入
        if (
          router.currentRoute.name === "receipt-edit" &&
          isInitReceiptDocumentDescription.value
        ) {
          console.log("收據編輯模式初始載入，跳過單據備註自動填入");
          isInitReceiptDocumentDescription.value = false;
          return;
        }

        if (newVal && newVal.length > 0 && newReceiptData.value.receipt_document_description_id) {
          const description = newVal.find(
            (ele) => ele.id == newReceiptData.value.receipt_document_description_id
          );
          if (description && description.description) {
            console.log(
              "選項載入完成，自動填入單據備註內容 - ID:",
              newReceiptData.value.receipt_document_description_id,
              "內容:",
              description.description
            );
            // 只有在 remark 為空時才自動填入
            if (!newReceiptData.value.remark || newReceiptData.value.remark === '') {
              newReceiptData.value.remark = description.description;
            }
          }
        }
      },
      { immediate: true }
    );

    const resetReceiptData = () => {
      newReceiptData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          stamp_id: 1,
          template_id: 1,
          remark_id: 3,
          customer_id: null,
          name_cn: "",
          name_en: "",
          mobile: "",
          email: "",
          project_id: null,
          project_name: "",
          address: "",
          receipt_items: [
            {
              id: 0,
              invoice_id: null,
              amount: null,
              payment_date: null,
              item_description: null,
              is_deposit: 0,
              payment_method_id: null,
              payment_step_id: null,
              is_reprint: false,
            },
          ],
          receipt_date: new Date().toISOString().substr(0, 10),
        })
      );
    };
    const calTotalAmount = () => {
      let total = 0;

      if (
        newReceiptData.value.receipt_items &&
        newReceiptData.value.receipt_items.length > 0
      ) {
        total += newReceiptData.value.receipt_items.reduce(
          (a, b) => a + (Number(b.amount) ? Number(b.amount) : 0),
          0
        );
      }
      newReceiptData.value.amount = total;
    };

    const invoiceSelected = async (item, invoice_id) => {
      console.log("invoiceSelected called - invoice_id:", invoice_id);
      console.log("invoiceSelected called - item:", item);
      console.log(
        "invoiceSelected called - item.id:",
        item.id,
        "是否為新建項目:",
        item.id <= 0
      );

      // 優先從 invoices.value 中查找（API 載入的資料），如果沒有則從 props.invoiceOptions 中查找
      let invoice = invoices.value.find((invoice) => {
        return Number(invoice.id) == Number(invoice_id);
      });

      if (!invoice && props.invoiceOptions) {
        invoice = props.invoiceOptions.find((invoice) => {
          return Number(invoice.id) == Number(invoice_id);
        });
      }

      console.log("找到的發票資料:", invoice);
      console.log("當前 invoices.value 長度:", invoices.value?.length || 0);
      console.log(
        "當前 props.invoiceOptions 長度:",
        props.invoiceOptions?.length || 0
      );
      // !item.amount&&
      if (invoice) {
        console.log("invoice", invoice);
        // var total = 0;
        // var arr = [];
        // if (item.is_deposit) {
        //   arr = newReceiptData.value.receipt_items.filter((ele) => {
        //     return ele.invoice_id == invoice_id && ele.is_deposit;
        //   });
        //   console.log("Deposit Array", arr);
        // } else {
        //   arr = newReceiptData.value.receipt_items.filter((ele) => {
        //     return ele.invoice_id == invoice_id;
        //   });
        //   console.log("Array", arr);
        // }

        //   total =
        //     arr.length > 0
        //       ? arr.reduce(
        //           (a, b) => a + (Number(b.amount) ? Number(b.amount) : 0),
        //           0
        //         )
        //       : 0;
        //   console.log("total", total);

        // 只有新建收據項目（id <= 0）才自動計算並填入未付餘額
        // 現有收據項目（id > 0）保持原有金額不變
        if (item.id <= 0) {
          // 自動填入未付餘額
          item.amount =
            Number(invoice.amount) - Number(invoice.total_paid);
          console.log("amount", item.amount);
        } else {
          console.log("編輯現有收據項目，保持原有金額:", item.amount);
        }

        // **修復：載入付款階段選項，確保使用正確的發票數據**
        console.log("=== invoiceSelected: 載入付款階段選項 ===");
        console.log("invoiceSelected: 發票ID:", invoice_id);
        console.log("invoiceSelected: 發票數據:", invoice);
        console.log("invoiceSelected: 發票數據類型:", typeof invoice);
        if (invoice) {
          console.log("invoiceSelected: 發票數據屬性:", Object.keys(invoice));
          console.log("invoiceSelected: paymentSteps 存在:", !!invoice.paymentSteps);
          console.log("invoiceSelected: payment_steps 存在:", !!invoice.payment_steps);
          console.log("invoiceSelected: paymentSteps 內容:", invoice.paymentSteps);
          console.log("invoiceSelected: payment_steps 內容:", invoice.payment_steps);
        }

        // 如果發票數據包含付款階段，直接使用該數據載入選項
        if (invoice && (invoice.paymentSteps || invoice.payment_steps)) {
          console.log("invoiceSelected: 使用發票數據載入付款階段選項");

          // **修復：如果之前載入為空陣列，先清除快取**
          if (paymentStepOptionsCache.value[invoice_id] &&
            paymentStepOptionsCache.value[invoice_id].length === 0) {
            console.log(`invoiceSelected: 清除發票 ${invoice_id} 的空快取，準備重新載入`);
            delete paymentStepOptionsCache.value[invoice_id];
          }

          await loadPaymentStepOptionsFromInvoiceData(invoice_id, invoice);
        } else {
          console.log("invoiceSelected: 使用原有邏輯載入付款階段選項");
          await loadPaymentStepOptions(invoice_id);
        }

        calTotalAmount();
      }
    };

    const calTotalRemainDepositAmount = (invoice_id) => {
      // 優先從 invoices.value 中查找（API 載入的資料），如果沒有則從 props.invoiceOptions 中查找
      let invoice = invoices.value.find((invoice) => {
        return Number(invoice.id) == Number(invoice_id);
      });

      if (!invoice && props.invoiceOptions) {
        invoice = props.invoiceOptions.find((invoice) => {
          return Number(invoice.id) == Number(invoice_id);
        });
      }

      if (!invoice) {
        return 0;
      }

      const depositAmount = Number(invoice.deposit_amount) || 0;
      const totalDepositPaid = Number(invoice.total_deposit_paid) || 0;
      return Math.max(depositAmount - totalDepositPaid, 0);
    };

    const handleDepositChange = (item, invoice_id) => {
      item.amount = 0;
      invoiceSelected(item, invoice_id);
      // if (invoice_id) {
      //   let invoice = props.invoiceOptions.find((invoice) => {
      //     return Number(invoice.id) == Number(invoice_id);
      //   });

      //   if (item.is_deposit) {
      //     item.amount = calTotalRemainDepositAmount(invoice_id);
      //   } else {
      //     item.amount =
      //       Number(invoice.amount) - Number(invoice.total_paid);
      //   }
      //   calTotalAmount();
      // }
    };

    const loading = ref(false);

    // 搜索函數
    const customerSearch = (options, search) => {
      return options.filter((item) => {
        return item.value.toLowerCase().includes(search.toLowerCase()) ||
          item.label.toLowerCase().includes(search.toLowerCase());
      });
    };

    const invoiceSearch = (options, search) => {
      return options.filter((item) => {
        return item.invoice_number.toLowerCase().includes(search.toLowerCase())
        // ||
        //   item.name_cn.toLowerCase().includes(search.toLowerCase()) ||
        //   item.address.toLowerCase().includes(search.toLowerCase());
      });
    };

    const receiptDescriptionSearch = (options, search) => {
      return options.filter((item) => {
        return item.description.toLowerCase().includes(search.toLowerCase());
      });
    };

    const paymentMethodSearch = (options, search) => {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    };

    const templateSearch = (options, search) => {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    };

    const stampSearch = (options, search) => {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    };

    const receiptRemarkSearch = (options, search) => {
      return options.filter((item) => {
        // 確保 item.title 存在且為字串
        const title = item.title || '';
        return title.toLowerCase().includes(search.toLowerCase());
      });
    };

    const receiptDocumentDescriptionSearch = (options, search) => {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    };

    // Toast 通知函數
    const makeToast = (variant = null, title = null, content = null) => {
      root.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    };

    // 隱藏函數
    const hide = () => {
      router.replace("/receipts/list");
    };

    // 提交函數
    const onSubmit = async () => {
      // 在提交前再次驗證收據編號唯一性
      await validateReceiptNumber();

      // 檢查收據編號唯一性驗證結果
      if (!receiptNumberValidation.value.isValid) {
        makeToast("danger", "Warning", "收據編號已存在，請使用其他編號");
        return;
      }
      root.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          loading.value = true;
          console.log("提交的收據數據:", newReceiptData.value);
          console.log("收據項目詳細:", newReceiptData.value.receipt_items);
          newReceiptData.value.receipt_items.forEach((item, index) => {
            console.log(`項目 ${index}:`, {
              invoice_id: item.invoice_id,
              amount: item.amount,
              amount_type: typeof item.amount,
              payment_date: item.payment_date,
              is_deposit: item.is_deposit,
            });
          });
          store
            .dispatch("receipt/editReceipt", newReceiptData.value)
            .then((response) => {
              loading.value = false;
              root.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              hide();
            })
            .catch((error) => {
              loading.value = false;
              root.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    };

    // 處理收款方式變更
    const handlePaymentMethod = (value, index) => {
      // 檢查所有 receipt_items 的 payment_method_id 是否相同
      const allPaymentMethods = newReceiptData.value.receipt_items
        .map((item) => item.payment_method_id)
        .filter((id) => id !== null && id !== undefined);

      // 檢查是否所有項目都有相同的 payment_method_id
      const uniquePaymentMethods = [...new Set(allPaymentMethods)];

      if (uniquePaymentMethods.length === 1) {
        // 所有項目都是同一種收款方式
        newReceiptData.value.payment_method_id = uniquePaymentMethods[0];
      } else if (uniquePaymentMethods.length > 1) {
        // 有不同的收款方式，設為綜合(18)
        newReceiptData.value.payment_method_id = 18;
      } else {
        // 沒有任何項目設置收款方式，保持當前選擇
        newReceiptData.value.payment_method_id = value;
      }
    };

    // 添加項目
    const addItem = (index) => {
      newReceiptData.value.receipt_items.splice(
        index + 1,
        0,
        JSON.parse(
          JSON.stringify({
            id: 0,
            amount: null,
            invoice_id: null,
            payment_date: null,
            item_description: null,
            is_deposit: 0,
            payment_method_id: null,
            payment_step_id: null,
            is_reprint: false,
          })
        )
      );
    };

    // 移除項目
    const removeItem = (index, id) => {
      // check number of record
      let record =
        newReceiptData.value &&
        newReceiptData.value.receipt_items &&
        newReceiptData.value.receipt_items.length;
      if (record <= 1) {
        makeToast("danger", "Warning", "請至少留有一個表單。");
      } else {
        // 直接在前端刪除項目，不調用API
        // 在提交時會一併處理所有變更
        root.$swal({
          title: "你確定嗎?",
          text: "此項目將被刪除。",
          showCancelButton: true,
          confirmButtonText: "刪除",
          cancelButtonText: "取消",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            // 直接從前端數組中移除項目
            newReceiptData.value.receipt_items.splice(index, 1);
            calTotalAmount();

            makeToast(
              "success",
              "成功",
              "項目已刪除，請記得提交表單以保存變更。"
            );
          }
        });
      }
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetReceiptData);

    // 獲取下一個收據編號
    const getNextReceiptNumber = async () => {
      try {
        loadingReceiptNumber.value = true;
        receiptNumberValidation.value = { message: "", isValid: true };

        const response = await store.dispatch("receipt/getNextReceiptNumber");
        if (response.data && response.data.receipt_number) {
          newReceiptData.value.receipt_number = response.data.receipt_number;
          receiptNumberValidation.value = {
            message: "已自動生成編號",
            isValid: true,
          };
        }
      } catch (error) {
        receiptNumberValidation.value = {
          message: "獲取編號失敗，請手動輸入",
          isValid: false,
        };
        console.error("獲取收據編號失敗:", error);
      } finally {
        loadingReceiptNumber.value = false;
      }
    };

    const onReceiptNumberInput = () => {
      // 清除之前的驗證結果，等待用戶完成輸入
      receiptNumberValidation.value = { message: "", isValid: true };
    };

    // 驗證收據編號唯一性
    const validateReceiptNumber = async () => {
      if (!newReceiptData.value.receipt_number) {
        receiptNumberValidation.value = { message: "", isValid: true };
        return;
      }

      try {
        const response = await store.dispatch("receipt/validateReceiptNumber", {
          receipt_number: newReceiptData.value.receipt_number,
          exclude_id:
            newReceiptData.value.id > 0 ? newReceiptData.value.id : null,
        });

        if (response.data) {
          receiptNumberValidation.value = {
            message: response.data.message,
            isValid: response.data.is_unique,
          };
        }
      } catch (error) {
        receiptNumberValidation.value = {
          message: "驗證失敗",
          isValid: false,
        };
        console.error("驗證收據編號失敗:", error);
      }
    };

    // 付款階段選項快取
    const paymentStepOptionsCache = ref({});

    // 強制重新渲染的計數器
    const forceUpdateCounter = ref(0);

    // 獲取付款階段選項
    const getPaymentStepOptions = (invoice_id) => {
      if (!invoice_id) return [];
      const options = paymentStepOptionsCache.value[invoice_id] || [];
      return options;
    };

    // 檢查付款階段選項是否已載入
    const isPaymentStepOptionsLoaded = (invoice_id) => {
      if (!invoice_id) return false;
      const isLoaded = paymentStepOptionsCache.value[invoice_id] !== undefined;
      console.log(
        `isPaymentStepOptionsLoaded: 發票 ${invoice_id} 載入狀態:`,
        isLoaded
      );
      console.log(
        `isPaymentStepOptionsLoaded: 當前快取:`,
        paymentStepOptionsCache.value
      );
      console.log(
        `isPaymentStepOptionsLoaded: 快取中的選項:`,
        paymentStepOptionsCache.value[invoice_id]
      );
      return isLoaded;
    };

    // 獲取付款階段的顯示文字（用於 v-select 顯示）
    const getPaymentStepDisplayTextById = (invoice_id, payment_step_id) => {
      if (!payment_step_id || !invoice_id) return "";

      // 如果選項還沒有載入，嘗試從發票資料中直接獲取
      if (!isPaymentStepOptionsLoaded(invoice_id)) {
        const invoice = invoices.value.find((inv) => inv.id === invoice_id);
        const paymentSteps =
          invoice?.paymentSteps || invoice?.payment_steps || [];
        const step = paymentSteps.find((s) => s.id === payment_step_id);
        if (step) {
          // 注意：這裡無法判斷 Re-Print 狀態和已付金額，因為選項還沒載入
          // 顯示基本格式，等選項載入後會自動更新為完整格式
          return `${step.step_phase} ${step.step_name} - $${Number(
            step.step_amount
          ).toFixed(2)} (載入中...)`;
        }
        return payment_step_id.toString();
      }

      const options = getPaymentStepOptions(invoice_id);
      const option = options.find((opt) => opt.id === payment_step_id);
      return option ? option.display_text : payment_step_id.toString();
    };

    // 為了向後兼容，創建一個別名函數
    const getPaymentStepDisplayText = getPaymentStepDisplayTextById;



    // **新增：從發票數據直接載入付款階段選項的函數**
    const loadPaymentStepOptionsFromInvoiceData = async (invoice_id, invoiceData) => {
      console.log(`=== loadPaymentStepOptionsFromInvoiceData 開始 ===`);
      console.log(`發票ID: ${invoice_id}`);
      console.log(`發票數據:`, invoiceData);
      console.log(`發票數據類型:`, typeof invoiceData);
      console.log(`發票數據是否為對象:`, typeof invoiceData === 'object' && invoiceData !== null);

      if (!invoice_id || !invoiceData) {
        console.log("loadPaymentStepOptionsFromInvoiceData: 參數不足");
        return;
      }

      // **修復：檢查是否已經載入過，但如果是空陣列且發票數據包含付款階段，則重新載入**
      const existingOptions = paymentStepOptionsCache.value[invoice_id];
      if (existingOptions !== undefined) {
        // 如果已經有選項且不為空，直接返回
        if (existingOptions.length > 0) {
          console.log(`loadPaymentStepOptionsFromInvoiceData: 發票 ${invoice_id} 的付款階段選項已載入且不為空，跳過`);
          return;
        }

        // 如果是空陣列，檢查發票數據是否包含付款階段
        const hasPaymentSteps = (invoiceData.paymentSteps && invoiceData.paymentSteps.length > 0) ||
          (invoiceData.payment_steps && invoiceData.payment_steps.length > 0);

        if (!hasPaymentSteps) {
          console.log(`loadPaymentStepOptionsFromInvoiceData: 發票 ${invoice_id} 確實沒有付款階段，保持空陣列`);
          return;
        }

        console.log(`loadPaymentStepOptionsFromInvoiceData: 發票 ${invoice_id} 之前載入為空但發票數據包含付款階段，重新載入`);
      }

      console.log(`loadPaymentStepOptionsFromInvoiceData: 開始載入發票 ${invoice_id} 的付款階段選項`);

      // **調試：列出發票數據的所有屬性**
      console.log(`發票數據的所有屬性:`, Object.keys(invoiceData));
      console.log(`發票數據的所有屬性和值:`, Object.entries(invoiceData));

      // 檢查 payment_steps 或 paymentSteps（支援兩種命名方式）
      // **修復：確保正確處理後端返回的 paymentSteps 數據**
      let paymentSteps = [];

      if (invoiceData.paymentSteps && Array.isArray(invoiceData.paymentSteps)) {
        paymentSteps = invoiceData.paymentSteps;
      } else if (invoiceData.payment_steps && Array.isArray(invoiceData.payment_steps)) {
        paymentSteps = invoiceData.payment_steps;
      } else if (invoiceData.payment_steps && typeof invoiceData.payment_steps === 'string') {
        // 如果是字符串，嘗試解析為JSON
        try {
          paymentSteps = JSON.parse(invoiceData.payment_steps);
        } catch (e) {
          console.warn('無法解析 payment_steps 字符串:', invoiceData.payment_steps);
          paymentSteps = [];
        }
      }

      console.log(`loadPaymentStepOptionsFromInvoiceData: 發票 ${invoice_id} 的付款階段:`, paymentSteps);
      console.log(`loadPaymentStepOptionsFromInvoiceData: 發票數據結構:`, {
        hasPaymentSteps: !!invoiceData.paymentSteps,
        hasPayment_steps: !!invoiceData.payment_steps,
        paymentStepsType: typeof invoiceData.paymentSteps,
        payment_stepsType: typeof invoiceData.payment_steps,
        paymentStepsIsArray: Array.isArray(invoiceData.paymentSteps),
        payment_stepsIsArray: Array.isArray(invoiceData.payment_steps),
        finalPaymentStepsLength: paymentSteps.length,
        finalPaymentSteps: paymentSteps
      });

      if (paymentSteps.length === 0) {
        console.log(`loadPaymentStepOptionsFromInvoiceData: 發票 ${invoice_id} 沒有付款階段`);
        paymentStepOptionsCache.value = {
          ...paymentStepOptionsCache.value,
          [invoice_id]: [],
        };
        forceUpdateCounter.value++;
        return;
      }

      // 檢查每個付款階段是否已存在收據記錄
      const options = [];
      const currentReceiptId = newReceiptData.value.id > 0 ? newReceiptData.value.id : null;

      console.log(`loadPaymentStepOptionsFromInvoiceData: 開始處理 ${paymentSteps.length} 個付款階段`);
      console.log(`loadPaymentStepOptionsFromInvoiceData: 當前收據ID:`, currentReceiptId);

      for (const step of paymentSteps) {
        let is_reprint = false;
        let total_paid_amount = 0;
        let step_amount = Number(step.step_amount) || 0;

        try {
          console.log(`loadPaymentStepOptionsFromInvoiceData: 檢查付款階段 ${step.id} 是否需要標記為 re-print`);
          const response = await store.dispatch("receipt/checkPaymentStepExists", {
            invoice_id: invoice_id,
            payment_step_id: step.id,
            exclude_receipt_id: currentReceiptId,
          });

          console.log(`loadPaymentStepOptionsFromInvoiceData: 付款階段 ${step.id} 檢查結果:`, response.data);

          // 獲取已付金額和階段金額
          if (response.data) {
            // 使用 total_paid_amount_display 來顯示已付金額（包含所有收據）
            total_paid_amount = Number(response.data.total_paid_amount_display) || 0;
            step_amount = Number(response.data.step_amount) || step_amount;
            is_reprint = response.data.is_reprint || false;

            console.log(`loadPaymentStepOptionsFromInvoiceData: 付款階段 ${step.id} 金額詳情`, {
              排除當前收據的已付金額: response.data.total_paid_amount,
              包含所有收據的已付金額: response.data.total_paid_amount_display,
              階段金額: step_amount,
              是否RePrint: is_reprint
            });
          }

          // 新邏輯：只有當已付金額達到或超過階段金額時才標記為 re-print
          if (is_reprint) {
            console.log(`loadPaymentStepOptionsFromInvoiceData: 付款階段 ${step.id} 標記為 re-print，已付金額 ${total_paid_amount} >= 階段金額 ${step_amount}`);
          } else {
            console.log(`loadPaymentStepOptionsFromInvoiceData: 付款階段 ${step.id} 不需要 re-print，已付金額 ${total_paid_amount} < 階段金額 ${step_amount}`);
          }
        } catch (error) {
          console.error(`loadPaymentStepOptionsFromInvoiceData: 檢查付款階段 ${step.id} 失敗:`, error);
          is_reprint = false;
          total_paid_amount = 0;
        }

        // 優化顯示格式：顯示階段名稱、金額和已付金額
        const displayText = `${step.step_phase} ${step.step_name ? step.step_name : ''} - $${step_amount.toFixed(2)} ${total_paid_amount ? `(已付: $${total_paid_amount.toFixed(2)})` : ''}${is_reprint ? " (Re-Print)" : ""}`;

        const option = {
          id: step.id,
          display_text: displayText,
          step_amount: step_amount,
          total_paid_amount: total_paid_amount,
          step_phase: step.step_phase,
          step_name: step.step_name,
          is_reprint: is_reprint,
        };

        options.push(option);
        console.log(`loadPaymentStepOptionsFromInvoiceData: 添加付款階段選項:`, option);
      }

      // 使用響應式方式更新快取
      paymentStepOptionsCache.value = {
        ...paymentStepOptionsCache.value,
        [invoice_id]: options,
      };

      // 強制重新渲染
      forceUpdateCounter.value++;

      console.log(`loadPaymentStepOptionsFromInvoiceData: 發票 ${invoice_id} 的付款階段選項載入完成:`, options);
      console.log(`loadPaymentStepOptionsFromInvoiceData: 更新後的快取:`, paymentStepOptionsCache.value);
      console.log(`loadPaymentStepOptionsFromInvoiceData: 強制更新計數器:`, forceUpdateCounter.value);
    };

    // 載入付款階段選項
    const loadPaymentStepOptions = async (invoice_id) => {
      if (!invoice_id) {
        console.log("loadPaymentStepOptions: invoice_id 為空，跳過載入");
        return;
      }

      // 如果已經載入過，直接返回
      if (paymentStepOptionsCache.value[invoice_id] !== undefined) {
        console.log(`loadPaymentStepOptions: 發票 ${invoice_id} 的付款階段選項已載入，跳過`);
        return;
      }

      console.log(`loadPaymentStepOptions: 開始載入發票 ${invoice_id} 的付款階段選項`);
      console.log("loadPaymentStepOptions: 當前發票列表:", invoices.value);

      const invoice = invoices.value.find((inv) => inv.id === invoice_id);
      console.log(`loadPaymentStepOptions: 找到的發票資料:`, invoice);

      if (!invoice) {
        console.warn(`loadPaymentStepOptions: 找不到發票 ${invoice_id}`);
        paymentStepOptionsCache.value = {
          ...paymentStepOptionsCache.value,
          [invoice_id]: [],
        };
        return;
      }

      // 使用新的函數載入付款階段選項
      await loadPaymentStepOptionsFromInvoiceData(invoice_id, invoice);
    };

    // 確保付款階段選項已載入
    const ensurePaymentStepOptionsLoaded = async (invoice_id) => {
      if (!invoice_id) return;

      // 如果選項已存在（即使為空陣列），則不需要重新載入
      const existingOptions = paymentStepOptionsCache.value[invoice_id];
      if (existingOptions !== undefined) {
        return;
      }

      // 如果 invoices.value 為空，先載入客戶發票
      if (!invoices.value || invoices.value.length === 0) {
        if (newReceiptData.value.customer_id) {
          try {
            const response = await store.dispatch(
              "receipt/fetchCustomerInvoice",
              {
                id: newReceiptData.value.customer_id,
              }
            );
            invoices.value = response.data.invoices;
          } catch (error) {
            console.error("載入客戶發票失敗:", error);
            return;
          }
        }
      }

      // 載入付款階段選項
      await loadPaymentStepOptions(invoice_id);
    };

    // 處理付款階段選擇變更
    // 新邏輯：只有當該付款階段的已付金額達到或超過階段金額時才標記為 re-print
    const handlePaymentStepChange = async (receipt, payment_step_id) => {
      // 步驟1：清空選擇的處理
      if (!payment_step_id) {
        receipt.payment_step_id = null;
        receipt.is_reprint = false;
        receipt.amount = 0;
        receipt.item_description = "";
        return;
      }

      // 步驟2：獲取發票和付款階段資料
      const invoice = invoices.value.find(
        (inv) => inv.id === receipt.invoice_id
      );
      if (!invoice) {
        console.error("handlePaymentStepChange: 找不到對應的發票");
        return;
      }

      const paymentSteps = invoice.paymentSteps || invoice.payment_steps || [];
      const paymentStep = paymentSteps.find(
        (step) => step.id === payment_step_id
      );
      if (!paymentStep) {
        console.error("handlePaymentStepChange: 找不到對應的付款階段");
        return;
      }

      // 步驟3：檢查是否為 Re-Print（新邏輯：比較已付金額與階段金額）
      const currentReceiptId =
        newReceiptData.value.id > 0 ? newReceiptData.value.id : null;

      try {
        console.log(
          `handlePaymentStepChange: 檢查付款階段 ${payment_step_id}，排除收據 ${currentReceiptId}`
        );
        const response = await store.dispatch(
          "receipt/checkPaymentStepExists",
          {
            invoice_id: receipt.invoice_id,
            payment_step_id: payment_step_id,
            exclude_receipt_id: currentReceiptId, // 關鍵：排除當前收據
          }
        );

        console.log(`handlePaymentStepChange: 檢查結果:`, response.data);

        // 步驟4：根據 Re-Print 狀態和剩餘金額設置金額和標記
        const stepAmount = Number(response.data.step_amount) || Number(paymentStep.step_amount) || 0;
        const totalPaidAmount = Number(response.data.total_paid_amount) || 0; // 用於邏輯判斷（排除當前收據）
        const totalPaidAmountDisplay = Number(response.data.total_paid_amount_display) || 0; // 用於顯示（包含所有收據）

        console.log(`handlePaymentStepChange: 付款階段 ${payment_step_id} 金額詳情`, {
          排除當前收據的已付金額: totalPaidAmount,
          包含所有收據的已付金額: totalPaidAmountDisplay,
          階段金額: stepAmount,
          是否RePrint: response.data.is_reprint
        });

        // 計算剩餘未付金額
        const remainingAmount = Math.max(stepAmount - totalPaidAmount, 0);

        // 新邏輯：只有當已付金額達到或超過階段金額時才標記為 re-print
        if (response.data && response.data.is_reprint) {
          // Re-Print 模式：已付金額達到或超過階段金額
          receipt.is_reprint = true;
          receipt.amount = 0; // 重複列印時金額設為 0，避免重複計算
          receipt.original_amount = stepAmount; // 保留原始金額供參考
          console.log(
            `handlePaymentStepChange: 設為 Re-Print 模式，已付金額 ${totalPaidAmount} >= 階段金額 ${stepAmount}，剩餘金額 ${remainingAmount}`
          );
        } else {
          // 首次付款模式或未達到階段金額 - 自動填入剩餘金額
          receipt.is_reprint = false;
          receipt.amount = remainingAmount; // 使用計算出的剩餘金額
          receipt.original_amount = stepAmount;
          console.log(
            `handlePaymentStepChange: 首次付款模式，已付金額 ${totalPaidAmount} < 階段金額 ${stepAmount}，自動填入剩餘金額 ${remainingAmount}`
          );
        }

        // 步驟5：自動設置項目描述
        const stepPhase = paymentStep.step_phase || '';
        const stepName = paymentStep.step_name || '';
        receipt.item_description = `${stepPhase} ${stepName}`.trim();

        // 步驟6：如果有最後一次支付記錄且為 Re-Print 模式，自動填入收款資訊
        if (response.data.last_payment_record && response.data.is_reprint) {
          const lastRecord = response.data.last_payment_record;
          console.log(`handlePaymentStepChange: 自動填入最後一次支付記錄:`, lastRecord);

          // 自動填入收款日期
          if (lastRecord.payment_date) {
            receipt.payment_date = lastRecord.payment_date;
          }

          // 自動填入收款方式
          if (lastRecord.payment_method_id) {
            receipt.payment_method_id = lastRecord.payment_method_id;
          }

          // 自動填入支票號碼（如果收款方式是支票）
          if (lastRecord.check_number && lastRecord.payment_method_id === 1) {
            receipt.check_number = lastRecord.check_number;
          }

          console.log(`handlePaymentStepChange: 已自動填入收款資訊 - 日期: ${lastRecord.payment_date}, 方式: ${lastRecord.payment_method_id}, 支票號碼: ${lastRecord.check_number || '無'}`);
        }

        // 步驟7：重新計算總金額
        calTotalAmount();
      } catch (error) {
        console.error("handlePaymentStepChange: 檢查付款階段失敗:", error);

        // 步驟8：錯誤降級處理 - 當無法檢查時，預設為首次付款，使用完整階段金額
        const stepAmount = Number(paymentStep.step_amount) || 0;
        receipt.is_reprint = false;
        receipt.amount = stepAmount; // 無法獲取已付金額時，使用完整階段金額
        receipt.original_amount = stepAmount;
        receipt.item_description = `${paymentStep.step_phase} ${paymentStep.step_name}`;
        calTotalAmount();

        // 顯示錯誤提示（如果有 toast 組件）
        console.warn(`無法檢查付款階段狀態，已按首次付款處理，使用完整階段金額 ${stepAmount}`);
      }
    };

    // 格式化金額顯示，處理 null/undefined/NaN 的情況
    const formatAmount = (amount) => {
      if (amount === null || amount === undefined || isNaN(Number(amount))) {
        return "0.00";
      }
      return Number(amount).toFixed(2);
    };

    // 計算未付金額
    const getUnpaidAmount = (totalAmount, totalPaid) => {
      const total = Number(totalAmount) || 0;
      const paid = Number(totalPaid) || 0;
      return Math.max(total - paid, 0);
    };

    // 獲取付款階段的原始金額
    const getPaymentStepAmount = (invoice_id, payment_step_id) => {
      if (!invoice_id || !payment_step_id) return 0;

      const invoice = invoices.value.find((inv) => inv.id === invoice_id);
      if (!invoice) return 0;

      const paymentSteps = invoice.paymentSteps || invoice.payment_steps || [];
      const step = paymentSteps.find((s) => s.id === payment_step_id);

      return step ? Number(step.step_amount) || 0 : 0;
    };

    // 組件掛載時初始化範本資訊和收據編號
    onMounted(async () => {
      if (newReceiptData.value.template_id) {
        changeTemplate(newReceiptData.value.template_id);
      }

      // 如果是新收據且沒有編號，自動獲取下一個編號
      if (
        (!newReceiptData.value.id || newReceiptData.value.id === 0) &&
        !newReceiptData.value.receipt_number
      ) {
        getNextReceiptNumber();
      }

      // 如果是新收據且沒有選擇備註，自動選擇"預設收據備註"
      if (
        (!newReceiptData.value.id || newReceiptData.value.id === 0) &&
        !newReceiptData.value.remark_id
      ) {
        // 查找"預設收據備註"
        const defaultRemark = props.receiptRemarkOptions.find(
          (remark) => remark.title === "預設收據備註" || remark.id === 3
        );

        if (defaultRemark) {
          console.log("自動選擇預設收據備註:", defaultRemark);
          newReceiptData.value.remark_id = defaultRemark.id;
          newReceiptData.value.receipt_remark = defaultRemark.content;
        }
      }

      // **修復：移除重複的發票載入邏輯，讓 watch 處理**
      // onMounted 中不再處理發票載入，避免與 watch 衝突
      console.log("onMounted 完成，發票載入由 watch 處理");
    });

    // 監聽 invoices 變化，自動載入付款階段選項
    watch(
      invoices,
      async (newInvoices) => {
        if (
          newInvoices &&
          newInvoices.length > 0 &&
          newReceiptData.value.id &&
          newReceiptData.value.id > 0
        ) {
          // 為現有收據項目載入付款階段選項
          const uniqueInvoiceIds = [
            ...new Set(
              newReceiptData.value.receipt_items
                .map((item) => item.invoice_id)
                .filter((id) => id)
            ),
          ];
          for (const invoiceId of uniqueInvoiceIds) {
            await loadPaymentStepOptions(invoiceId);
          }
        }
      },
      { immediate: true }
    );

    // 監聽 props.invoiceOptions 變化，處理從發票生成收據的情況
    watch(
      () => props.invoiceOptions,
      async (newInvoiceOptions) => {
        console.log("props.invoiceOptions 變化:", newInvoiceOptions);
        if (newInvoiceOptions && newInvoiceOptions.length > 0) {
          // 檢查是否是從發票生成收據的情況（URL 包含 invoice_id 參數）
          const urlInvoiceId = router.currentRoute.query.invoice_id;
          if (urlInvoiceId) {
            console.log(`檢測到從發票 ${urlInvoiceId} 生成收據`);

            // 找到對應的發票數據
            const invoice = newInvoiceOptions.find(inv => Number(inv.id) === Number(urlInvoiceId));
            if (invoice) {
              console.log("=== props.invoiceOptions 監聽器：找到發票數據 ===");
              console.log("發票數據:", invoice);
              console.log("發票數據類型:", typeof invoice);
              console.log("發票數據屬性:", Object.keys(invoice));
              console.log("發票的付款階段數據:", {
                paymentSteps: invoice.paymentSteps,
                payment_steps: invoice.payment_steps,
                paymentStepsLength: (invoice.paymentSteps || []).length,
                payment_stepsLength: (invoice.payment_steps || []).length,
                paymentStepsType: typeof invoice.paymentSteps,
                payment_stepsType: typeof invoice.payment_steps
              });

              // 將發票數據添加到 invoices.value 中，確保其他邏輯能正常工作
              if (!invoices.value.find(inv => Number(inv.id) === Number(urlInvoiceId))) {
                invoices.value.push(invoice);
                console.log("已將發票添加到 invoices.value");
              }

              // **修復：確保付款階段數據存在後再載入選項**
              const paymentSteps = invoice.paymentSteps || invoice.payment_steps || [];
              if (paymentSteps.length > 0) {
                console.log(`發票 ${urlInvoiceId} 有 ${paymentSteps.length} 個付款階段，開始載入選項`);

                // **修復：如果之前載入為空陣列，先清除快取**
                if (paymentStepOptionsCache.value[urlInvoiceId] &&
                  paymentStepOptionsCache.value[urlInvoiceId].length === 0) {
                  console.log(`清除發票 ${urlInvoiceId} 的空快取，準備重新載入`);
                  delete paymentStepOptionsCache.value[urlInvoiceId];
                }

                await loadPaymentStepOptionsFromInvoiceData(urlInvoiceId, invoice);
              } else {
                console.log(`發票 ${urlInvoiceId} 沒有付款階段數據`);
                // 即使沒有付款階段，也要設置空陣列到快取中，避免重複載入
                paymentStepOptionsCache.value = {
                  ...paymentStepOptionsCache.value,
                  [urlInvoiceId]: [],
                };
                forceUpdateCounter.value++;
              }
            } else {
              console.warn(`在 invoiceOptions 中找不到發票 ${urlInvoiceId}`);
            }
          }
        }
      },
      { immediate: true, deep: true }
    );

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newReceiptData,
      calTotalAmount,
      invoices,
      invoiceSelected,
      trigger,
      newProjectOptions,
      filteredOptions,
      changeTemplate,
      info,
      handleDepositChange,
      calTotalRemainDepositAmount,
      // handleProjectChange, // 已註釋項目選擇功能
      handleCustomerChange,
      // 新增的收據編號相關功能
      loadingReceiptNumber,
      receiptNumberValidation,
      getNextReceiptNumber,
      validateReceiptNumber,
      onReceiptNumberInput,
      // 付款階段相關功能
      paymentStepOptionsCache,
      getPaymentStepOptions,
      getPaymentStepDisplayText, // 向後兼容的別名函數
      loadPaymentStepOptions,
      loadPaymentStepOptionsFromInvoiceData, // 新增這個函數
      ensurePaymentStepOptionsLoaded,
      handlePaymentStepChange,
      isPaymentStepOptionsLoaded,
      getPaymentStepDisplayTextById,
      forceUpdateCounter,
      // 金額格式化功能
      formatAmount,
      getUnpaidAmount,
      getPaymentStepAmount,
      // 搜索函數
      customerSearch,
      invoiceSearch,
      receiptDescriptionSearch,
      paymentMethodSearch,
      templateSearch,
      stampSearch,
      receiptRemarkSearch,
      receiptDocumentDescriptionSearch,
      // 其他函數
      makeToast,
      hide,
      onSubmit,
      handlePaymentMethod,
      addItem,
      removeItem,
      setRemarkContent,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
ol li {
  margin-bottom: 0.5rem;
}
</style>
